import "./CollectionComponent.scss";
import React, { useState, useMemo, useEffect } from "react";

import config from "../config/index";
import { useProducts } from "../hooks/useProducts";
import useHover from "../hooks/useHover";
import mockedProducts from "./mockedProducts";

const CollectionComponent = ({ title, collection }) => {
  /* Check if the user is performing a search */
  const queryParams = new URL(document.location.toString()).searchParams;

  /* Get search entered by the user */
  const search = queryParams.get("q");

  /* Keep track selected filters */
  const [selectedFilters, setSelectedFilters] = useState({
    colours: [],
    sizes: [],
  });

  /* Fetch data */
  const { products, isLoading, error, filters } = useProducts(
    collection,
    search,
    selectedFilters
  );

  const closeMobileSidebar = () => {
    $(".sidebar").removeClass("is-active");
    $("body").removeClass("js-drawer-open js-drawer-open--search");
  };

  const openMobileSidebar = () => {
    $(".sidebar").addClass("is-active");
    $("body").addClass("js-drawer-open js-drawer-open--search");

    // @ts-ignore
    theme.a11y.trapFocus({
      $container: $(".sidebar"),
    });

    window.scrollTo(0, 0);

    // Bind events
    // @ts-ignore
    theme.a11y.lockMobileScrolling(config.namespace);
  };

  return (
    <>
      <header className="section-header">
        <div className="filters-mobile">
          <div className="filters-icon" onClick={openMobileSidebar}></div>
        </div>
        <h1 className="section-header__title">
          {(title && title !== "null" ? title : search).replace(
            /\\u(\w\w\w\w)/g,
            function (a, b) {
              var charcode = parseInt(b, 16);
              return String.fromCharCode(charcode);
            }
          )}
        </h1>
      </header>
      <div className="collection-container">
        <div className={`sidebar`}>
          <div className="sidebar-title">
            <h3>Filters</h3>
            <div className="sidebar-close" onClick={closeMobileSidebar}></div>
          </div>
          {filters && (
            <div className="filters">
              <div className="filters-group">
                <h5>Colours</h5>
                <div className="filters-group-wrapper">
                  {filters.colours.map((colorName) => (
                    <div className="filter">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          if (!e.target.checked) {
                            /* If the value is now off, remove that color from the state */
                            setSelectedFilters({
                              sizes: selectedFilters.sizes,
                              colours: selectedFilters.colours.filter(
                                (c) => c !== colorName
                              ),
                            });
                          } else {
                            /* Add that colour to our state */
                            setSelectedFilters({
                              sizes: selectedFilters.sizes,
                              colours: [...selectedFilters.colours, colorName],
                            });
                          }
                        }}
                      />
                      <label>{colorName}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="main">
          {isLoading && (
            <div className="loading">
              <h5>Loading...</h5>
            </div>
          )}
          {!isLoading && mockedProducts.length === 0 && error && (
            <h5>{error}</h5>
          )}
          {!isLoading && products.length === 0 && <h5>No results</h5>}
          {!isLoading &&
            products.length > 0 &&
            products.map((product) => (
              <CollectionItem
                collection={collection}
                search={search}
                product={product}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export const CollectionItem = ({
  collection,
  search,
  product,
  filterColors = [],
}) => {
  /* Keep track of which variant color is hovered */
  const [hoveredColour, setHoveredColour] = useState(null);

  /* Check if we have a hero variant or select the first product as the main one */
  const mainProduct =
    product.products.find((p) => p.is_hero_variant === true) ||
    product.products[0];

  /* Get hovered image */
  const image = hoveredColour
    ? hoveredColour.images[0].src
    : mainProduct.images[0].src;

  let price = 0;
  if (mainProduct?.compareDisplayPrice > 0) {
    price = hoveredColour
      ? hoveredColour.compareDisplayPrice
      : mainProduct.compareDisplayPrice;
  } else {
    price = hoveredColour
      ? hoveredColour.displayPrice
      : mainProduct.displayPrice;
  }

  return (
    <article className="collection-item">
      <a
        className="product-grid-item"
        aria-label={product.name}
        href={`/products/${mainProduct.handle.toLowerCase()}?collection=${collection}`}
        style={{
          pointerEvents: "all",
        }}
      >
        <div className="image">
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              backgroundColor: "white",
            }}
            src={
              image
                ? image
                : `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mOcsHJlPQAGFgJjGhxX/wAAAABJRU5ErkJggg==`
            }
          />
        </div>
        <div className="swatches">
          {product.products
            .sort((p1) => (p1.is_hero_variant === true ? -1 : 1))
            .map((colour) => {
              return (
                <CollectionItemImageHover
                  image={{
                    src: colour.swatchUrl,
                  }}
                  search={null}
                  collection={collection}
                  setHoveredColour={setHoveredColour}
                  variant={colour}
                />
              );
            })}
        </div>
        <div className="description">
          <label>
            {mainProduct.groupTitle.replace(
              "&reg;",
              String.fromCodePoint(0x000ae)
            )}
          </label>
        </div>
        <div className="price">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <label
              style={{
                textDecoration:
                  mainProduct?.compareDisplayPrice > 0
                    ? "line-through"
                    : "none",
              }}
            >
              ${price}
            </label>
            {mainProduct?.compareDisplayPrice > 0 && (
              <label
                style={{
                  marginLeft: "10px",
                  color: "#FF0000",
                }}
              >
                $
                {hoveredColour
                  ? hoveredColour.displayPrice
                  : mainProduct.displayPrice}
              </label>
            )}
          </div>
          {}
        </div>
      </a>
    </article>
  );
};

export const CollectionItemImageHover = ({
  collection,
  variant,
  search,
  image,
  setHoveredColour,
}) => {
  const [ref] = useHover({
    onHover: () => {
      setHoveredColour(variant);
    },
    onLeave: () => {},
    enabled: window.innerWidth > 768,
  });

  return (
    image && (
      <a
        href={`/products/${variant.handle.toLowerCase()}?colorId=${
          variant.shopify_id
        }&collection=${search ? "search" : collection}`}
        style={{
          pointerEvents: window.innerWidth > 768 ? "all" : "none",
        }}
      >
        {/* @ts-ignore} */}
        <div
          ref={ref}
          className="swatch-image"
          style={{
            backgroundImage: `url(${image.src})`,
          }}
          onClick={(e) => {
            if (window.innerWidth <= 768) {
              e.preventDefault();
              e.stopPropagation();
            }

            if (image.src) {
              setHoveredColour(variant);
            }
          }}
        />
      </a>
    )
  );
};

export default CollectionComponent;
